

import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { IoMdClose } from "react-icons/io";
import React from "react";

function getToastBgColor(color: string) {
  switch (color) {
    case "red":
      return "#DA291C"; 
    case "green":
      return "#26890D"; 
    case "blue":
      return "#007CB0";  
    case "yellow":
      return "#ca8a04";  
    default:
      return color;
  }
}

export function showAppToast({
  icon,
  message,
  color = "green",
  undo,
  duration = 45000,
}: {
  icon?: React.ReactNode;
  message: React.ReactNode;
  color?: "red" | "green" | "blue" | "yellow" | string;
  undo?: { label?: string; onClick: () => void };
  duration?: number;
}) {
  toast.dismiss();
  toast(
    <AppToastContent icon={icon} message={message} color={color} undo={undo} />, {
      position: "top-right",
      autoClose: duration,
      closeButton: false,
      hideProgressBar: true,
      style: { background: getToastBgColor(color), color: '#fff', borderRadius: '0', padding: 0 },
      icon: false,
    }
  );
}

function AppToastContent({ icon, message, color, undo }: {
  icon: React.ReactNode;
  message: React.ReactNode;
  color?: string;
  undo?: { label?: string; onClick: () => void };
}) {
  return (
    <div className="flex items-center px-4 py-3 w-full gap-1">
      <span className={`text-white text-base mr-1`}>{icon}</span>
      <div className="flex-1">
        <div className="text-xs">{message}</div>
      </div>
      {undo && (
        <>
        <button
          className="underline text-white font-medium text-sm mx-2"
          onClick={() => {
            toast.dismiss();
            undo.onClick();
          }}
        >
          {undo.label || "Undo"}
        </button>
        <div className="mx-2">|</div>
        </>
      )}
      
      <button
        className="ml-2 text-white hover:text-gray-200"
        onClick={() => toast.dismiss()}
        aria-label="Close"
      >
        <IoMdClose className="text-lg" />
      </button>
    </div>
  );
}

export function AppToastContainer() {
  return <ToastContainer newestOnTop className='custom-toastify'/>;
}
